<section id="modal">
  <div class="headermodal">
    <div class="iconmodal" (click)="download()">
      <icon icon="/assets/icons/csv.svg" width="40px" height="30px"></icon>
    </div>
    <div class="titlemodal">{{ title }}</div>
    <div class="iconmodalclose" mat-dialog-close></div>
  </div>
  <div class="body">
    <tablecomponent
      #tableComponent
      [columnsConfig]="configTable"
      [values]="list"
      [headerConfig]="TableHeaderConfig"
      title="Lista de Erros"
      height="calc(85vh - 50px)"
    ></tablecomponent>
  </div>
  <!-- <spinner *ngIf="loading">Carregando...</spinner> -->
</section>
